module.exports = __webpack_public_path__ + "img/success.png?v=9cb3683f";